export default {
	'radio': 'Radio',
	'box_select': 'BoxSelect',
	'select': 'Select',
	'slider': 'Scroller',
	'vertical_slider': 'VerticalSlider',
	'human_map': 'HumanMap',
}
